<template>
  <tr class="table-item">
    <td>
      <v-checkbox v-model="isActive" :ripple="false" hide-details></v-checkbox>
    </td>

    <td>
      {{ item.name }}
    </td>
  </tr>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
    },
    selectedNetworks: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isActive: {
      get() {
        let isActive = false;
        this.selectedNetworks.forEach((network) => {
          if (network.id === this.item.id) isActive = true;
        });
        return isActive;
      },
      set(val) {
        this.emitChange(val);
      },
    },
  },
  methods: {
    emitChange(event) {
      const action = event ? "select" : "deselect";
      this.$emit("change", {
        action,
        network: {
          id: this.item.id,
          organizationId: this.item.organizationId,
          name: this.item.name,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-item {
  &:last-child {
    margin-right: 0;
  }
}
</style>
